'use strict';

$(function () {
  $('[data-toggle="popover"]').popover({html: true, trigger: 'focus'});
});
